define('TescoMobile_Checkout/js/view/monthly-payment/after-continue-content',['uiComponent', 'Magento_Checkout/js/model/quote'], function (Component, quote) {
  'use strict';

  const config = window.checkoutConfig.tescomobile.monthly_payment;
  const paymentMethod = quote.getData('customer_tm_monthly_payment_method') || 'NONE';
  return Component.extend({
    defaults: {
      paymentMethod: paymentMethod,
      template: 'TescoMobile_Checkout/monthly-payment/after-continue-content',
      image: config.after_continue_image,
      text: paymentMethod === 'CARD' ? config.card_content : config.after_continue_content
    }
  });
});

